export default {
  bodyBackground: '#fff',
  defaultFontSize: '16px',
  primaryColor: '#2a93a7',
  dangerColor: '#ff4d4f',
}
